import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import ComptePage from './containers/ComptePage';
import ConfirmationCompte from './containers/ConfirmationCompte';
import ConfirmationRenouvellement from './containers/ConfirmationRenouvellement';
import ConnectedHomePage from './containers/ConnectedHomePage';
import ContactPage from './containers/ContactPage';
import CreationComptePage from './containers/CreationComptePage';
import DemandeRemboursement from './containers/DemandeRemboursement';
import DepannagePage from './containers/DepannagePage';
import DonneesPersonnellesPage from './containers/DonneesPersonnelles';
import ForbiddenPage from './containers/ForbiddenPage';
import HomePage from './containers/HomePage';
import MentionsLegalesPage from './containers/MentionsLegales';
import NotFoundPage from './containers/NotFoundPage';
import { setOffline } from './redux/GlobalRedux';

const App = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    window.addEventListener('offline', () => {
      dispatch(setOffline(true));
    });
    window.addEventListener('online', () => {
      dispatch(setOffline(false));
    });

    return () => {
      window.removeEventListener('offline', () => {
        dispatch(setOffline(false));
      });
      window.removeEventListener('online', () => {
        dispatch(setOffline(false));
      });
    };
  }, []);
  return (
    <Switch>
      <Route path="/" component={HomePage} exact />
      <Route path="/forbidden" component={ForbiddenPage} exact />
      <Route path="/confirmation-signature" component={ConfirmationCompte} exact />
      <Route path="/confirmation-renouvellement" component={ConfirmationRenouvellement} exact />
      <Route path="/mentions-legales" component={MentionsLegalesPage} exact />
      <Route path="/donnees-personnelles" component={DonneesPersonnellesPage} exact />
      <Route path="/creation-compte" component={CreationComptePage} exact />
      <PrivateRoute path="/accueil" component={ConnectedHomePage} exact />
      <PrivateRoute path="/contrats" component={ComptePage} exact />
      <Route path="/depannage" component={DepannagePage} exact />
      <Route path="/contact" component={ContactPage} exact />
      <PrivateRoute path="/demande-remboursement" component={DemandeRemboursement} exact />
      <Route component={NotFoundPage} />
    </Switch>
  );
};

export default App;
